const initialState = {
  status: "invalid",
};

function PrototypeReducer(state = initialState, action) {
  switch (action.type) {
    case "PROTOTYPE_RESET":
      return {
        status: "invalid",
      };
    case "PROTOTYPE_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PROTOTYPE_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "PROTOTYPE_FAILURE":
      return {
        ...state,
        status: "failure",
        err: action.err,
      };
    default:
      return state;
  }
}
export default PrototypeReducer;
